export enum ProcessStep {
  LoadModel = 'load-model',
  LoadSkeleton = 'load-skeleton',
  EditSkeleton = 'edit-skeleton',
  WeightSkin = 'weight-skin',
  AnimationsListing = 'animations-export',
  StepExportToFile = 'export-to-file',
  BindPose = 'BindPose'
}
